<template>
  <div class="container">
    <div
      class="row"
      v-for="(item, index) in data"
      :key="'row-'+index"
      :style="getRowStyle()"
    >
      <div
        class="column"
        v-for="(col, colIndex) in columns"
        :key="'cell-'+index+'-'+colIndex"
        :style="getColumnStyle(col)"
      >
        <div style="display: flex">
          <div :style="item[col.prop + 'Style']">{{ item[col.prop] }}</div>
          <div v-if="htmlShow && col.html" v-html="col.html" style="margin-left: 10px" @click="clickFun"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "miniTable",
  props :{
    columns: Array,
    data: {
      type: Array,
      required: true
    },
    htmlShow: {
      type: Boolean,
      default: false
    },
    showHeader: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    getRowStyle() {
      const gridTemplateColumns = this.columns.map(col => {
        if (col.width === 'auto') return 'minmax(min-content, 1fr)';
        if (col.width) {
          return col.width + 'px';
        }
        return '1fr';
      }).join(' ')
      return {
        gridTemplateColumns: gridTemplateColumns
      }
    },
    getColumnStyle(col) {
      return {
        textAlign: col.align || 'left',
        justifyContent: this.getJustify(col.align)
      };
    },
    getJustify(align) {
      switch(align) {
        case 'center': return 'center';
        case 'right': return 'flex-end';
        default: return 'flex-start';
      }
    },
    clickFun() {
      this.$emit('edit-open');
    }
  }
}
</script>

<style scoped>
.container {
  display: grid;
  width: 100%;
}

.row {
  display: grid;
  align-items: center;
  min-height: 30px;
  border-bottom: 1px solid #eee;
}

.row:last-child {
  border-bottom: none;
}

.column {
  padding: 5px 5px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  word-break: break-word;
  justify-content: center;
}
</style>
